import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { BrowserTracing } from '@sentry/browser';

if (environment.production) {
  Sentry.init({
    dsn: 'https://feb64d3c5e2149289b4f1158bafb9f20@o1412259.ingest.sentry.io/6751112',
    environment: environment.production ? 'production' : 'local',
    integrations: [
      new BrowserTracing({
        // tracingOrigins: ['localhost', 'https://experttabla.ro/calculator'],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
  });

  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
